import { __decorate } from "tslib";
import { AsnProp, AsnPropTypes } from "@peculiar/asn1-schema";
import { HashAlgAndValue } from "./hash_alg_and_value";
export class LogotypeReference {
    constructor(params = {}) {
        this.refStructHash = [];
        this.refStructURI = [];
        Object.assign(this, params);
    }
}
__decorate([
    AsnProp({ type: HashAlgAndValue, repeated: "sequence" })
], LogotypeReference.prototype, "refStructHash", void 0);
__decorate([
    AsnProp({ type: AsnPropTypes.IA5String, repeated: "sequence" })
], LogotypeReference.prototype, "refStructURI", void 0);
